/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/views/web/product/conponents/MmuSkuList/index.tsx
 * @Description: 商品详情-需求清单商品列表
 */
import { QuoteMode, AccountPeriodEnum, BillingPeriodEnum, NetPriceSource } from 'libs/enums';
import {
  useTradeAgreementContext,
  useTradeModeContext,
  useProductDetailContext,
} from 'views/web/product/context';
import { getEnumLabel } from 'libs/utils';
import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import styles from './index.module.scss';
import useAreaCookie from 'hooks/useAreaCookie';
import { apiQueryMmuSkuList, apiConcreteBuyOrderAgain } from 'api/mall';
import { formatCurrency } from '../../helper';
import numeral from 'numeral';
import AgreementModal from '@/biz-components/web/AgreementModal';
import { shopSimulateSplit } from 'api/user';
import { checkConcreteAtribute } from 'api/order';
import { Input, Table, Tooltip, Select, Popover, message, Modal } from 'antd';
import { numberMutiply, numberDivide } from 'libs/compute';
import ProductDetailPriceDescModal from '../ProductDetailPriceDescModal';
// import SelectConcreteSupplier from 'comps/SelectConcreteSupplier';
import { cls } from 'reactutils';
import _ from 'lodash';
import { debounce } from 'rambdax';
import TableActions from './TableActions';
const FIXED_COLUMNS = 'FIXED_COLUMNS';
const defaultFixed = [
  'priceWithTax',
  'shopQuantity',
  'totalPriceWithTax',
  'totalPriceWithOutTax',
  'pourLocation',
  'comment',
  'action',
];
type TablePaginationPosition =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

const pagination = {
  pageSize: 10,
  showSizeChanger: false,
  showQuickJumper: false,
  showTotal: (total) => `共 ${total} 条`,
  style: { marginTop: '16px' },
  position: ['bottomRight'] as TablePaginationPosition[], // 分页位置
};
/**
 * 商品清单
 */
export default forwardRef(function MmuSkuList({ skuDetail, shop }: any, ref) {
  const [skuList, setSkuList] = useState([]);
  const quoteMode = skuList?.length ? skuList[0]?.quoteMode : '';
  const [skuForPriceCalculate, setSkuForPriceCalculate] = useState(null);
  const { selectTradeAgreement, setSelectTradeAgreement } = useTradeAgreementContext();
  const [manifestEnable, setManifestEnable] = useState(true);
  const { selectTradeMode, setSelectTradeMode } = useTradeModeContext();
  const { setShowLoading } = useProductDetailContext();
  const { getCookieAreaSysNo } = useAreaCookie();
  const [agreementVisible, setAgreementVisible] = useState(false);
  const [agreementModalSysNo, setAgreementModalSysNo] = useState('');
  const [attrListObj, setAttrListObj] = useState({ showUsePart: false, station: [] });
  const [stationInfo, setStationInfo] = useState(null);
  const [skuInfo, setSkuInfo] = useState(null);
  const getSkuList = async (sku?: any, orderSysNo?: string, orderType?: string) => {
    // orderSysNo和orderType存在的情况为 商品砼混凝土再次购买直接加入需求清单
    try {
      let apiMethod = apiQueryMmuSkuList;
      let params: any = {
        areaSysNo: getCookieAreaSysNo(),
      };
      if (orderSysNo && orderType) {
        params = {
          ...params,
          orderSysNo,
          orderType,
        };
        apiMethod = apiConcreteBuyOrderAgain;
      } else {
        params = {
          ...params,
          agreementSysNo: selectTradeAgreement?.sysNo,
          netPriceType: selectTradeAgreement?.netPriceType,
          accountPeriod: selectTradeMode.accountPeriod,
          billingPeriod: selectTradeMode.billingPeriod,
          supplierSysNo: skuDetail.supplierSysNo,
          mallSkuList: sku ? (Array.isArray(sku) ? sku : [...skuList, sku]) : skuList,
        };
      }
      setManifestEnable(false);
      const { data } = await apiMethod({
        json: params,
      });
      setShowLoading(false);
      setManifestEnable(true);
      if (!data) return;
      setSkuInfo(data);
      let newSkuList = [];
      if (data?.mallSkuList?.length) {
        newSkuList = data.mallSkuList.map((sku) => {
          sku.priceWithOutTaxHasInput = false;
          sku.priceWithTaxHasInput = false;
          sku.mallSkuSysNo = sku.sysNo;
          // 没有网价
          var NoNetPrice = sku.netPriceWithoutTax == null && sku.netPriceWithTax == null;
          // 由采购方自行填写价格
          var purchaserCustomizePrice =
            sku.skuForPriceCalculate && sku.skuForPriceCalculate.purchaserCustomizePrice;
          var noUnitConversionRate =
            sku.skuForPriceCalculate && sku.skuForPriceCalculate.noUnitConversionRate;
          if (
            sku.netPriceSource != null &&
            (NoNetPrice || purchaserCustomizePrice || noUnitConversionRate)
          ) {
            if (sku.quoteMode === QuoteMode.WITHOUT_TAX_TYPE) {
              sku.priceWithOutTaxHasInput = true;
            } else {
              sku.priceWithTaxHasInput = true;
            }
          }
          return sku;
        });
        if (orderSysNo && orderType) {
          // 找出上一次下单的交易规则和交易方式
          const lastTradeAgreementArr = _.filter(
            skuDetail?.tradeAgreementEntityList,
            (item) => item.sysNo === data?.agreementSysNo,
          );
          if (lastTradeAgreementArr?.length > 0) {
            setSelectTradeAgreement(lastTradeAgreementArr[0]);
            const lastTradeModeArr = _.filter(
              lastTradeAgreementArr[0]?.discountByMethodList,
              (item) => item.accountPeriod === data?.accountPeriod,
            );
            if (lastTradeModeArr?.length > 0) {
              setSelectTradeMode(lastTradeModeArr[0]);
            }
            setSkuList(newSkuList);
          } else {
            getSkuList(newSkuList); // 使用默认选中的交易规则获取最新的需求清单
          }
        } else {
          setSkuList(newSkuList);
        }
      }
      data.station = data.station?.map((v) => ({ ...v, label: v.name, value: v.sysNo }));
      setAttrListObj(data);
      // 设定默认值
      if (!stationInfo || !stationInfo.sysNo) {
        setStationInfo(data.station?.[0]);
      }
    } catch (error) {}
  };
  useImperativeHandle(ref, () => {
    return {
      getSkuList,
    };
  });
  const skuSaleStatus = (sku) => {
    const canSale = sku.agreementCanSale !== false && sku.areaCanSale && sku.productCanSale;
    let tip;
    if (!canSale) {
      tip = !sku.productCanSale
        ? '此商品已下架'
        : !sku.areaCanSale
        ? '此商品不在此地区范围内销售'
        : '暂不支持该交易规则';
    }
    return {
      canSale,
      tip,
    };
  };
  const handleBlurPriceWithOutTax = function (sku) {
    if (sku.priceWithOutTax.endsWith('.')) {
      sku.priceWithOutTax = sku.priceWithOutTax.slice(0, sku.priceWithOutTax.length - 1);
    }
    var price = numberMutiply(sku.priceWithOutTax, 1 + sku.taxRate / 100);
    sku.priceWithTax = numeral(price).format('0.00[000000]');
    setSkuList([...skuList]);
  };

  const handleBlurPriceWithTax = function (sku) {
    if (sku.priceWithTax.endsWith('.')) {
      sku.priceWithTax = sku.priceWithTax.slice(0, sku.priceWithTax.length - 1);
    }
    var price = numberDivide(sku.priceWithTax, 1 + sku.taxRate / 100);
    sku.priceWithOutTax = numeral(price).format('0.00[000000]');
    setSkuList([...skuList]);
  };
  const priceWithOutTaxTip =
    quoteMode === QuoteMode.WITHOUT_TAX_TYPE
      ? selectTradeAgreement
        ? '系统自动计算'
        : ''
      : '除税单价=含税单价 /（1+税率）';
  const priceWithTaxTip =
    quoteMode !== QuoteMode.WITHOUT_TAX_TYPE
      ? selectTradeAgreement
        ? '系统自动计算'
        : ''
      : '含税单价=除税单价*（1+税率）';
  const priceWithOutTaxSumTip =
    quoteMode === QuoteMode.WITHOUT_TAX_TYPE
      ? selectTradeAgreement
        ? '系统自动计算'
        : ''
      : '除税总价=含税总价 /（1+税率）';
  const priceWithTaxSumTip =
    quoteMode !== QuoteMode.WITHOUT_TAX_TYPE
      ? selectTradeAgreement
        ? '系统自动计算'
        : ''
      : '含税总价=除税总价*（1+税率）';
  const disabledCreateBtn = () => {
    if (!skuList || skuList.length === 0) {
      return true;
    }
    return !_.every(skuList, (sku) => {
      let hasPrice = true;
      if (sku.priceWithOutTaxHasInput) {
        hasPrice = sku.priceWithOutTax && sku.priceWithOutTax !== '0';
      }
      if (sku.priceWithTaxHasInput) {
        hasPrice = sku.priceWithTax && sku.priceWithTax !== '0';
      }
      return (
        sku.shopQuantity > 0 &&
        sku.agreementCanSale !== false &&
        sku.areaCanSale &&
        hasPrice &&
        sku.productCanSale
      );
    });
  };
  const netPriceSource = !!skuList?.length && skuList[0].netPriceSource;

  const [fixedColumnsKey, setFixedColumnsKey] = useState(defaultFixed);
  useEffect(() => {
    const localFixed = window.localStorage.getItem(FIXED_COLUMNS);
    if (localFixed) {
      setFixedColumnsKey(JSON.parse(localFixed));
    }
  }, []);
  const tableColumns = function () {
    var prefixArr = [
      {
        title: '商品名称',
        dataIndex: 'name',
        width: '164px',
      },
    ];
    var suffixArr = [
      {
        title: '品牌',
        dataIndex: 'brandName',
        width: '110px',
      },
      {
        title: () => {
          if (priceWithOutTaxTip) {
            return (
              <div>
                除税单价(元)
                <Tooltip title={priceWithOutTaxTip}>
                  <i className="iconfont icon-tishishuoming" />
                </Tooltip>
              </div>
            );
          }
          return '除税单价(元)' as string;
        },
        dropdownTitle: '除税单价',
        dataIndex: 'priceWithOutTax',
        width: '140px',
        render: (_, record) => {
          if (record.priceWithOutTaxHasInput) {
            return (
              <Input
                value={record.priceWithOutTax}
                className={cls(
                  'product-table-td-input',
                  (!skuSaleStatus(record).canSale || !manifestEnable) && 'disabled',
                )}
                disabled={!skuSaleStatus(record).canSale || !manifestEnable}
                onBlur={(e) => {
                  setShowLoading(true);
                  debounce(() => {
                    getSkuList(skuList);
                  }, 300)(e);
                }}
                onInput={(e) => {
                  var val = e.target.value.replace(/^\D*(\d*(?:\.\d{0,8})?).*$/g, '$1');
                  record.priceWithOutTax = val;
                  handleBlurPriceWithOutTax(record);
                  setSkuList([...skuList]);
                }}
              />
            );
          }
          if (!record.priceWithOutTax) return '--';
          return (
            <span>
              {formatCurrency(record.priceWithOutTax)}
              {record.quoteMode === QuoteMode.WITHOUT_TAX_TYPE &&
                !record.priceWithTaxHasInput &&
                selectTradeAgreement && (
                  <i
                    className="iconfont icon-jisuanqi computed-icon"
                    onClick={() => {
                      setSkuForPriceCalculate(record.skuForPriceCalculate);
                    }}
                  />
                )}
            </span>
          );
        },
      },
      {
        title: '税率',
        dataIndex: 'taxRate',
        width: '70px',
        render: (val) => val + '%',
      },
    ];
    if (netPriceSource) {
      suffixArr.splice(1, 0, {
        title:
          getEnumLabel({
            enums: NetPriceSource,
            value: netPriceSource,
          }) + '(元)',
        width: '200px',
        dropdownTitle: getEnumLabel({
          enums: NetPriceSource,
          value: netPriceSource,
        }),
        dataIndex:
          quoteMode === QuoteMode.WITHOUT_TAX_TYPE ? 'netPriceWithoutTax' : 'netPriceWithTax',
        render: (val) => (val ? formatCurrency(val) : '--'),
      });
    }
    var attributeArr = skuDetail.attributeList.map(function (attr, index) {
      return {
        title: attr.attributeName,
        dataIndex: attr.attributeName,
        width: '110px',
        isAttr: true,
        isMmuAttr: false,
        suffix: '',
        isPopoverColumn: false,
        attributeSysNo: attr.attributeSysNo,
        render: (_, record) => {
          const value = record.attributeList?.find((v) => v.attributeSysNo === attr.attributeSysNo)
            ?.categoryAttributeValueList?.[0];
          if (!skuSaleStatus(record).canSale && index === 0) {
            return (
              <div>
                <Tooltip
                  title={skuSaleStatus(record).tip}
                  visible={true}
                  autoAdjustOverflow={false}
                  getPopupContainer={(trigger: { parentNode: any }) => trigger.parentNode}
                >
                  {value?.attributeValue || '--'}
                </Tooltip>
              </div>
            );
          }
          return value?.attributeValue || '--';
        },
      };
    });
    var mmuAttributeArr = skuDetail.mmuAttributeList.map(function (attr) {
      return {
        title: attr.attributeName,
        dataIndex: attr.attributeName,
        width: '120px',
        isAttr: false,
        isMmuAttr: true,
        suffix: '',
        isPopoverColumn: false,
        attributeSysNo: attr.attributeSysNo,
        ellipsis: true,
        render: (_, record) => {
          const curMmuAttr = record.mmuAttributeList.find(
            (mmuAttr) => mmuAttr.attributeSysNo === attr.attributeSysNo,
          );

          if (!curMmuAttr) return '';
          if (curMmuAttr.hasCustomize)
            return curMmuAttr.categoryAttributeValueList[0]?.attributeValue;
          return curMmuAttr.categoryAttributeValueList?.map((i) => i.attributeValue)?.join('、');
        },
      };
    });
    const fixed = [
      {
        title: () => (
          <>
            含税单价(元)
            {priceWithTaxTip && (
              <Popover
                color="#515151"
                content={<p style={{ margin: 0, color: '#fff' }}>{priceWithTaxTip}</p>}
                trigger="hover"
              >
                <i className={cls('iconfont icon-tishishuoming')} />
              </Popover>
            )}
          </>
        ),
        dropdownTitle: '含税单价',
        width: '120px',
        dataIndex: 'priceWithTax',
        fixed: 'right',
        render: (_, record) => {
          if (record.priceWithTaxHasInput) {
            return (
              <Input
                value={record.priceWithTax}
                className={cls(
                  'product-table-td-input',
                  (!skuSaleStatus(record).canSale || !manifestEnable) && 'disabled',
                )}
                disabled={!skuSaleStatus(record).canSale || !manifestEnable}
                onInput={(e) => {
                  var val = e.target.value.replace(/^\D*(\d*(?:\.\d{0,8})?).*$/g, '$1');
                  record.priceWithTax = val;
                  setSkuList([...skuList]);
                }}
                onBlur={(e) => {
                  setShowLoading(true);
                  debounce(() => {
                    getSkuList(skuList);
                  }, 300)(e);
                }}
                onChange={() => {
                  handleBlurPriceWithTax(record);
                }}
              />
            );
          }
          if (!record.priceWithTax) return '--';
          return (
            <span>
              {formatCurrency(record.priceWithTax)}
              {record.quoteMode === QuoteMode.WITH_TAX_TYPE &&
                !record.priceWithOutTaxHasInput &&
                selectTradeAgreement && (
                  <i
                    className={cls('iconfont icon-jisuanqi', styles.computed_icon)}
                    onClick={() => {
                      setSkuForPriceCalculate(record.skuForPriceCalculate);
                    }}
                  />
                )}
            </span>
          );
        },
      },
      {
        title: '数量',
        width: '100px',
        dataIndex: 'shopQuantity',
        fixed: 'right',
        render: (_, record) => {
          return (
            <div className={styles.flx}>
              <Input
                value={record.shopQuantity}
                className={cls(
                  'product-table-td-input',
                  (!skuSaleStatus(record).canSale || !manifestEnable) && 'disabled',
                )}
                disabled={!skuSaleStatus(record).canSale || !manifestEnable}
                onInput={(e) => {
                  var val = e.target.value.replace(/^\D*(\d*(?:\.\d{0,8})?).*$/g, '$1');
                  record.shopQuantity = val;
                  setSkuList([...skuList]);
                }}
                onBlur={(e) => {
                  setShowLoading(true);
                  debounce(() => {
                    getSkuList(skuList);
                  }, 300)(e);
                }}
              />
              <span className="product-table-td-txt">{record.unitName}</span>
            </div>
          );
        },
      },
      {
        title: () => (
          <>
            含税总价(元)
            {priceWithTaxSumTip && (
              <Popover
                color="#515151"
                content={<p style={{ margin: 0, color: '#fff' }}>{priceWithTaxSumTip}</p>}
                trigger="hover"
              >
                <i className={cls('iconfont icon-tishishuoming')} />
              </Popover>
            )}
          </>
        ),
        dropdownTitle: '含税总价',
        width: '120px',
        dataIndex: 'totalPriceWithTax',
        fixed: 'right',
        render: (_, record) => {
          if (!record.totalPriceWithTax) return '--';
          return (
            <span>
              {formatCurrency(record.totalPriceWithTax)}
              {record.quoteMode === QuoteMode.WITH_TAX_TYPE &&
                !record.priceWithOutTaxHasInput &&
                selectTradeAgreement && (
                  <i
                    className={cls('iconfont icon-jisuanqi', styles.computed_icon)}
                    onClick={() => {
                      setSkuForPriceCalculate(record.skuForPriceCalculate);
                    }}
                  />
                )}
            </span>
          );
        },
      },
      {
        title: () => (
          <>
            除税总价(元)
            {priceWithOutTaxSumTip && (
              <Popover
                color="#515151"
                content={<p style={{ margin: 0, color: '#fff' }}>{priceWithOutTaxSumTip}</p>}
                trigger="hover"
              >
                <i className={cls('iconfont icon-tishishuoming')} />
              </Popover>
            )}
          </>
        ),
        width: '120px',
        dropdownTitle: '除税总价',
        dataIndex: 'totalPriceWithOutTax',
        fixed: 'right',
        render: (_, record) => {
          if (!record.totalPriceWithOutTax) return '--';
          return (
            <span>
              {formatCurrency(record.totalPriceWithOutTax)}
              {record.quoteMode === QuoteMode.WITHOUT_TAX_TYPE &&
                !record.priceWithOutTaxHasInput &&
                selectTradeAgreement && (
                  <i
                    className="iconfont icon-jisuanqi computed-icon"
                    onClick={() => {
                      setSkuForPriceCalculate(record.skuForPriceCalculate);
                    }}
                  />
                )}
            </span>
          );
        },
      },
      skuDetail?.concreteFlag && {
        title: () => (
          <>
            <span style={{ color: 'red' }}>* </span>浇筑部位
          </>
        ),
        dropdownTitle: '浇筑部位',
        width: '130px',
        dataIndex: 'pourLocation',
        fixed: 'right',
        render: (_, record) => (
          <Input
            value={record.pourLocation}
            maxLength={200}
            className={cls(
              'product-table-td-input',
              (!skuSaleStatus(record).canSale || !manifestEnable) && 'disabled',
            )}
            disabled={!skuSaleStatus(record).canSale || !manifestEnable}
            onInput={(e: any) => {
              record.pourLocation = e.target.value;
              setSkuList([...skuList]);
            }}
          />
        ),
      },
      // skuDetail?.concreteFlag && {
      //   title: '使用分包',
      //   width: '150px',
      //   dataIndex: 'subContractorName',
      //   fixed: 'right',
      //   render: (_, record) => (
      //     <SelectConcreteSupplier
      //       style={{ width: '100%' }}
      //       onChange={(value, option, e) => {
      //         if (option) {
      //           record.subContractorSysNo = option.value;
      //           record.subContractorName = option.label;
      //         } else {
      //           record.subContractorSysNo = undefined;
      //           record.subContractorName = '';
      //         }
      //         setSkuList([...skuList]);
      //       }}
      //     />
      //   ),
      // },

      {
        title: '备注',
        width: '110px',
        dataIndex: 'comment',
        fixed: 'right',
        render: (_, record) => (
          <Input
            value={record.comment}
            maxLength={200}
            className={cls(
              'product-table-td-input',
              (!skuSaleStatus(record).canSale || !manifestEnable) && 'disabled',
            )}
            disabled={!skuSaleStatus(record).canSale || !manifestEnable}
            onInput={(e) => {
              record.comment = e.target.value;
              setSkuList([...skuList]);
            }}
          />
        ),
      },
      {
        title: '操作',
        width: '70px',
        dataIndex: 'action',
        fixed: 'right',
        render: (_, record, skuIndex) => (
          <span
            className="table-del-btn"
            onClick={() => {
              skuList.splice(skuIndex, 1);
              // setSkuList([...skuList]);
              getSkuList(skuList);
            }}
          >
            删除
          </span>
        ),
      },
    ].filter(Boolean);
    var arr = [...prefixArr, ...attributeArr, ...mmuAttributeArr, ...suffixArr, ...fixed];
    arr[1].isPopoverColumn = true;
    return arr;
  };
  let column = tableColumns();
  column = column.map((v) => {
    return {
      ...v,
      fixed: fixedColumnsKey.includes(v.dataIndex) ? 'right' : 'none',
      title:
        v.dataIndex === 'action' ? (
          <TableActions
            column={column}
            fixedColumnsKey={fixedColumnsKey}
            onChange={(keys) => {
              setFixedColumnsKey(keys);
              window.localStorage.setItem(FIXED_COLUMNS, JSON.stringify(keys));
            }}
          />
        ) : (
          v.title
        ),
    };
  });
  column = [
    ...column.filter((v) => v.fixed === 'none'),
    ...column.filter((v) => v.fixed !== 'none'),
  ];
  const handleCreate = async () => {
    if (skuDetail?.concreteFlag) {
      let isInvalid = false;
      skuList.forEach((sku) => {
        if (!sku.pourLocation || sku.pourLocation.length == 0) {
          isInvalid = true;
        }
      });
      if (isInvalid) {
        message.error('浇筑部位为必填项，请检查！');
        return;
      }
    }

    const totalInventory = skuList.reduce((acc, sku) => {
      return acc + +sku.shopQuantity;
    }, 0);

    var curSku = skuList?.[0];

    if (!!curSku.inventory && +totalInventory > +curSku.inventory) {
      message.error(
        curSku.name + '库存不足，收货区域可售总库存为' + curSku.inventory + curSku.unitName,
      );
      return;
    }

    const afterCheck = async () => {
      var skuListParam = skuList.filter((sku) => {
        var hasPrice = true;
        if (sku.priceWithOutTaxHasInput) {
          hasPrice = sku.priceWithOutTax && sku.priceWithOutTax !== '0';
        }
        if (sku.priceWithTaxHasInput) {
          hasPrice = sku.priceWithTax && sku.priceWithTax !== '0';
        }
        return sku.shopQuantity > 0 && hasPrice && sku.agreementCanSale && sku.areaCanSale;
      });
      var params = {
        areaSysNo: getCookieAreaSysNo(),
        type: 0,
        mmuProductEnable: true,
        simulateSplitGroup: [
          {
            tradeAgreementSysNo: selectTradeAgreement.sysNo,
            netPriceType: skuDetail.netPriceType,
            shopSysNo: shop.sysNo,
            supplierSysNo: skuDetail.supplierSysNo,
            paymentType: selectTradeMode.accountPeriod,
            billingPeriod: selectTradeMode.billingPeriod,
            skuList: skuListParam.map((v) => {
              if (skuDetail.concreteFlag) {
                v.concreteAttributeList = v.attributeList;
              }
              return v;
            }),
            stationSysNo: stationInfo?.value,
            stationName: stationInfo?.label,
            stationNo: stationInfo?.stationNo,
            skuType: skuDetail.skuType,
          },
        ],
      };
      setShowLoading(true);
      try {
        const { code } = await shopSimulateSplit(params);
        if (code !== 200) {
          setShowLoading(false);
          return;
        }
        const form = document.getElementById('productDetaiMmuSubmitForm');
        const input = document.getElementById('productDetaiMmuSubmitData');
        input.value = JSON.stringify(params);
        form.submit();
      } catch (error) {
        setShowLoading(false);
      }
    };

    const getCheckData = (sku) => {
      const attrs = (sku.attributeList || [])
        .concat(sku.mmuAttributeList || [])
        ?.map((attr) => ({
          attributeNo: attr.costCenterCode,
          attributeName: attr.attributeName,
          attributeValueList: attr.categoryAttributeValueList?.map((t) => ({
            attributeValueNo: t.costCenterCode,
            attributeValueName: t.attributeValue,
          })),
        }))
        ?.filter((item) => item.attributeValueList?.length > 0);
      const data = {
        stationId: stationInfo?.stationNo,
        attributeList: attrs,
      };
      return data;
    };

    Promise.all(skuList.map((sku) => checkConcreteAtribute(getCheckData(sku))))
      .then((results) => {
        // results 是一个数组，包含了每个 checkUserExists 调用解决的结果
        const wrongs = [];
        results.forEach((item, i) => {
          if (item.code !== 200) {
            wrongs.push(
              <div>
                第{i + 1}条数据: {item.message}
              </div>,
            );
          }
        });
        if (wrongs.length > 0) {
          Modal.confirm({
            content: <>{wrongs}</>,
            okText: '继续下单',
            cancelText: '取消',
            onCancel: () => {
              return;
            },
            onOk: () => {
              afterCheck();
            },
          });
        } else {
          afterCheck();
        }
      })
      .catch((error) => {
        // 如果任何一个 promise 失败了，这里的 catch 会被调用
        console.error('Error:', error);
      });
  };
  return (
    <div className='mmu-sku-list'>
      {skuList && skuList.length > 0 && (
        <>
          <div className={styles.product_detail_mmu_sku_list}>
            <div className={styles.mmu_sku_list_head}>
              <div className={styles.mmu_sku_list_head_left}>
                <span className={styles.mmu_sku_list_head_title}>需求清单</span>

                {selectTradeAgreement?.name && (
                  <span className={styles.mmu_sku_list_head_agreement}>
                    交易规则：
                    <span
                      className={styles.mmu_sku_list_head_agreement_txt}
                      onClick={() => {
                        setAgreementModalSysNo(selectTradeAgreement.sysNo);
                        setAgreementVisible(true);
                      }}
                      title={selectTradeAgreement?.name}
                    >
                      {selectTradeAgreement.name}
                    </span>
                  </span>
                )}
                {selectTradeMode?.sysNo && (
                  <span className={styles.mmu_sku_list_head_mode}>
                    交易方式：
                    {selectTradeMode.accountPeriod === AccountPeriodEnum.CUSTOM.value
                      ? selectTradeMode.billingPeriod === BillingPeriodEnum.OTHER.value &&
                        !!selectTradeAgreement.billingPeriodOtherDays
                        ? `结算付款（${selectTradeAgreement.billingPeriodOtherDays}天后一次性付款）`
                        : getEnumLabel({
                            enums: BillingPeriodEnum,
                            value: selectTradeMode.billingPeriod,
                          })
                      : getEnumLabel({
                          enums: AccountPeriodEnum,
                          value: selectTradeMode.accountPeriod,
                        })}
                  </span>
                )}
              </div>
              {!!attrListObj?.station?.length && (
                <span className={styles.mmu_sku_list_head_site}>
                  <span className={styles.flexnone}>
                    <span className={styles.mmu_sku_list_head_site_require_symbol}>*</span>
                    配送站点：
                  </span>
                  <Select
                    value={stationInfo?.sysNo}
                    style={{ width: '100%' }}
                    onChange={(_, item) => {
                      setStationInfo(item);
                    }}
                    options={attrListObj.station}
                  />
                </span>
              )}
            </div>
            <Table
              columns={column}
              dataSource={skuList || []}
              scroll={{ x: 1500 }}
              style={{ margin: '9px 0' }}
              pagination={pagination}
            />
            <div className={styles.mmu_sku_list_footer}>
              <div className={styles.summary_footer_price_unit} style={{ textAlign: 'center' }}>
                <span>合计：</span>
              </div>
              <div className={styles.summary_footer_num_unit}>
                <span className={styles.count_num}>{skuInfo?.shopQuantitySum}</span>
                <span>&nbsp;{skuList?.[0]?.unitName}</span>
              </div>
              <div className={styles.summary_footer_price_unit}>
                <span className={styles.total_price}>
                  {formatCurrency(skuInfo?.priceWithTaxSum)}
                </span>
              </div>
              <div className={styles.summary_footer_price_unit}>
                <span className={styles.total_price}>
                  {formatCurrency(skuInfo?.priceWithOutTaxSum)}
                </span>
              </div>
            </div>

            <div className={styles.create_btn_wrap}>
              <a
                className={cls(styles.btn, disabledCreateBtn() && styles.disabled)}
                onClick={() => {
                  handleCreate();
                }}
              >
                立即下单
              </a>
              <form
                id="productDetaiMmuSubmitForm"
                action="/purchaser/trade/shopCreate"
                method="post"
                style={{ display: 'none' }}
              >
                <input id="productDetaiMmuSubmitData" name="data" hidden="hidden" />
              </form>
            </div>
            <AgreementModal
              visible={agreementVisible}
              sysNo={agreementModalSysNo}
              onCancel={() => {
                setAgreementVisible(false);
              }}
            />
            <style jsx>{`
        :global(.ant-table-cell) {
          padding: 10px !important;
        }
        :global(.product-table-td-input) {
          flex: 1;
          height: 30px;
          border: 1px solid #D6D6D6;
          width: 100%;
          padding: 0 4px;
        }
        :global(.product-table-td-txt) {
          margin-left: 8px;
        }
        :global(.table-del-btn) {
          color: var(--rv-primary-color);
          cursor: pointer;
        }
        .mmu-sku-list :global(.ant-select-dropdown .ant-select-item) {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 28px;
          padding-left: 19px;
          padding-right: 16px;
          cursor: pointer;
        }
      `}</style>
          </div>
          <ProductDetailPriceDescModal
            title="报价因素"
            visible={!!skuForPriceCalculate}
            onClose={() => {
              setSkuForPriceCalculate(null);
            }}
            skuForPriceCalculate={skuForPriceCalculate || {}}
          />
        </>
      )}
    </div>
  );
});
